import { render } from "./tambah.vue?vue&type=template&id=6762924b"
import script from "./tambah.vue?vue&type=script&lang=js"
export * from "./tambah.vue?vue&type=script&lang=js"

import "./tambah.vue?vue&type=style&index=0&id=6762924b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__